import { Component, ViewChild, Input, OnInit } from '@angular/core';
import { DxDataGridComponent, DxListModule } from 'devextreme-angular';
import { RecSearchService } from '../../rec-search-service';
import { RecNameSearchRowVM, RecDocVM, PartyVM } from '../../../shared/viewmodels/ISearchService';
import { retry } from 'rxjs/operators';
import { RecDocVMTab } from '../../../shared/viewmodels/RecDocVMTab';

@Component({
  selector: 'app-rec-name-search-detail',
  providers: [RecSearchService],
  templateUrl: './rec-name-search-detail.component.html',
  styleUrls: ['./rec-name-search-detail.component.css'],
  preserveWhitespaces: true
})
export class RecNameSearchDetailComponent implements OnInit {
  console = console;
  @Input() DocID: number;
  public isLoading: boolean = true;
  public recDocVM: RecDocVM;
  public recDocVMTabs: RecDocVMTab[];
  @Input() rowData: RecNameSearchRowVM;
  error: any;
  constructor(private service: RecSearchService) {
    this.isLoading = true;
    this.console.log(`DocID in constructor: ${this.DocID}`);
    this.recDocVMTabs = new Array<RecDocVMTab>();
  }

  ngOnInit() {
    console.log(`DocID in OnIint: ${this.DocID}`);
    this.service.getRecDoc(this.DocID).subscribe(
      data => {
        this.isLoading = false;
        this.recDocVM = data;
        //let info: RecDocVMTab = {
        //  title: "Doc Info",
        //  type: "Info",
        //  payload: { info: this.recDocVM }

        //};
        //this.recDocVMTabs.push(info);

        let torstees: RecDocVMTab = {
          title: "Parties",
          type: "Parties",
          payload: {
            grantors: this.recDocVM.docTors,
            grantees: this.recDocVM.docTees
          }
        };
        this.recDocVMTabs.push(
          torstees
        );

        
        let reftoby: RecDocVMTab = {
          title: "References",
          type: "Referrals",
          payload:
          {
            refto: this.recDocVM.docRefTo,
            refby: this.recDocVM.docRefBy,
            trans: this.recDocVM.docTrans
          }
        };
        this.recDocVMTabs.push(reftoby);

        let address: RecDocVMTab = {
          title: "Address",
          type: "Address",
          payload: this.recDocVM.docAddress
        }

        this.recDocVMTabs.push(address);
      },
      error => { this.error = error }
    );
  }
  getTabs(): RecDocVMTab[] {
    this.console.log(this.recDocVMTabs);
    return this.recDocVMTabs;
  }
  getRecDoc(docId: number) {
    console.log(`getRecDoc: ${docId}`);
    let retVar: RecDocVM;

    //this.service.getRecDoc(docId).subscribe(
    //  data => retVar = data
    //);
    //console.log(`returned: ${retVar}`);
    //var rightTab = this.recsresults.find(el => el.docID === docId);
    return this.service.getRecDoc(docId);
  }

  ItemClick(e) {

  }
}
